// pages/AppRemitoReactTable.jsx
import React, { useState, useEffect, useMemo, useCallback } from "react";
import styled from "styled-components";
import { useFilters, useSortBy, usePagination } from "react-table";
import { getRemitos, deleteRemito, getRemitoById } from "../helpers/rutaRemitos";
import Table from "./TableContainer";
import ModalFormRemito from "../components/ModalFormRemito";

import ModalOrdenPagoRemito from "../components/ModalOrdenPagoRemito"; // 👈 NUEVO
import ModalOrdenCobroRemitos from "../components/ModalOrdenCobroRemitos";

import moment from "moment";
import { Button } from "react-bootstrap";

import { generarPDFRemito } from "../helpers/pdfRemitos";
import { generarPDFRemitoCampo } from "../helpers/pdfRemitoCampo";
import ModalSaldoInicialRemito from "../components/ModalSaldoInicialRemito";

import ModalVerOrdenPagoRemitos from "../components/ModalVerOrdenPagoRemitos";
import { generarPDFOrdenPagoRemito } from "../helpers/pdfOrdenPagoRemito";

const Styles = styled.div`
  .table-container { overflow: auto; height: 720px; }
  table { border: 1px solid black; border-spacing: 0; font-size: 13px; width: 100%; }
  th, td { padding: 0.5rem; border-bottom: 1px solid black; border-right: 1px solid black; }
  th { background-color: #778899; position: sticky; top: 0; z-index: 3; text-align: center; font-size: 12px; }
  td { background-color: white; }
  .pagination { padding: 0.5rem; background-color: #778899; font-size: 15px; font-weight: bold; }
  .action-btn { border: none; background: transparent; cursor: pointer; }
  .action-btn--edit { color: #0d6efd; }
  .action-btn--del  { color: #dc3545; }
  .action-btn--op   { color: #198754; } /* 👈 verde para OP */

  /* Sticky header para las primeras 3 columnas (Edita/Borra/PDF) */
  .table-container thead th:nth-child(1) { position: sticky; left: 0;    z-index: 6; }
  .table-container thead th:nth-child(2) { position: sticky; left: 50px; z-index: 6; }
  .table-container thead th:nth-child(3) { position: sticky; left: 100px; z-index: 6; }
`;

const fmtMoney = (n) =>
  Number(n || 0).toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const fmtDate = (d) => {
  if (!d) return "-";
  const date = new Date(d);
  const year  = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day   = String(date.getUTCDate()).padStart(2, "0");
  return `${day}/${month}/${year}`;
};


export default function AppRemitoReactTable() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showSaldo, setShowSaldo] = useState(false);

  const [remitoSel, setRemitoSel] = useState(null);
  const [showModalEdit, setShowModalEdit] = useState(false);

  // >>> NUEVO: Orden de Pago Remitos
  const [showModalOP, setShowModalOP] = useState(false);
  const [proveedorOP, setProveedorOP] = useState(null);
  const [clienteOP, setClienteOP] = useState(null);
  const [preseleccionOP, setPreseleccionOP] = useState([]); // [{_id,codrem,fecha,factura,pactado,pagado,saldo}]


  // >>> NUEVO: Orden de Cobro Remitos
  const [showModalOC, setShowModalOC] = useState(false);
  const [clienteOC, setClienteOC] = useState(null);
  const [proveedorOC, setProveedorOC] = useState(null); // filtro opcional
  const [preseleccionOC, setPreseleccionOC] = useState([]);

  const [filtros, setFiltros] = useState({
    desde: "",
    hasta: "",
    proveedor: "",
    cliente: "",
    chofer: "",
    remDesde: "",
    remHasta: "",
  });

  const setF = (k, v) => setFiltros((prev) => ({ ...prev, [k]: v }));

  const limpiarFiltros = () =>
    setFiltros({
      desde: "",
      hasta: "",
      proveedor: "",
      cliente: "",
      chofer: "",
      remDesde: "",
      remHasta: "",
    });

  const quickHoy = () => {
    const hoy = new Date();
    const y = hoy.getFullYear();
    const m = String(hoy.getMonth() + 1).padStart(2, "0");
    const d = String(hoy.getDate()).padStart(2, "0");
    const iso = `${y}-${m}-${d}`;
    setF("desde", iso);
    setF("hasta", iso);
  };

  const quickUltimos7 = () => {
    const hoy = new Date();
    const d7 = new Date(hoy);
    d7.setDate(hoy.getDate() - 6);
    const toISO = (dt) =>
      `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(
        dt.getDate()
      ).padStart(2, "0")}`;
    setF("desde", toISO(d7));
    setF("hasta", toISO(hoy));
  };

  //4 funciones para filtros
  function toStartOfDay(dateStr) {
    if (!dateStr) return null;
    const d = new Date(dateStr + "T00:00:00");
    return isNaN(d) ? null : d;
  }
  function toEndOfDay(dateStr) {
    if (!dateStr) return null;
    const d = new Date(dateStr + "T23:59:59");
    return isNaN(d) ? null : d;
  }
  function norm(v) {
    return (v ?? "")
      .toString()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
      .toLowerCase();
  }
  function safeGet(obj, path) {
    try {
      return path.split(".").reduce((o, k) => (o && o[k] != null ? o[k] : ""), obj) ?? "";
    } catch {
      return "";
    }
  }

  //ya existentes
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const resp = await getRemitos();
      const list = Array.isArray(resp) ? resp : (resp?.remitos || []);
      list.sort(
        (a, b) =>
          (b.codrem || 0) - (a.codrem || 0) || new Date(b.fecha) - new Date(a.fecha)
      );
      setData(list);
    } catch (e) {
      console.error("❌ Remitos:", e);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  const handleCloseEdit = () => {
    setShowModalEdit(false);
    setRemitoSel(null);
    setTimeout(() => fetchData(), 0);
  };

  const borrar = useCallback(async (id) => {
    if (!window.confirm("¿Eliminar (lógico) este remito?")) return;
    try {
      await deleteRemito(id);
      fetchData();
    } catch (e) {
      console.error("❌ deleteRemito:", e);
    }
  }, [fetchData]);

  // ---------- OP (nuevo) ----------
  // const openOPFromRow = (row) => {
  //   const r = row.original;

  //   // Necesitamos proveedor
  //   const proveedor = r.proveedor;
  //   if (!proveedor?._id) {
  //     alert("El remito no tiene 'Proveedor' asociado.");
  //     return;
  //   }
  //   setProveedorOP(proveedor);

  //   // Cliente como filtro opcional
  //   const cliente = r.cliente?._id ? r.cliente : null;
  //   setClienteOP(cliente);

  //   // Preselección con el remito clickeado
  //   const pactado = Number(r.totalCompra || 0);
  //   const pagado = Number(r.pagadoProveedor || 0); // si el back lo calcula, viene acá
  //   const saldo = pactado - pagado;

  //   const pre =
  //     saldo > 0.01
  //       ? [{
  //           _id: r._id,
  //           codrem: r.codrem,
  //           fecha: r.fecha,
  //           factura: r.factura ? "Sí" : "",
  //           pactado,
  //           pagado,
  //           saldo: Number(saldo.toFixed(2)),
  //         }]
  //       : [];

  //   setPreseleccionOP(pre);
  //   setShowModalOP(true);
  // };
const openOPFromRow = (row) => {
  const r = row.original;

  const proveedor = r.proveedor;
  if (!proveedor?._id) {
    alert("El remito no tiene 'Proveedor' asociado.");
    return;
  }
  setProveedorOP(proveedor);

  // ✅ IMPORTANTE: no filtrar por cliente por defecto
  setClienteOP(null);

  const compraA = Number(r.totalCompraA || 0);
  const compraB = Number(r.totalCompraB || 0);
  const flete   = Number(r.flete || 0);

  const pactado = compraA + compraB + flete;
  const pagado  = Number(r.pagadoProveedor || 0);
  const saldo   = pactado - pagado;

  const pre = saldo > 0.01 ? [{
    _id: r._id,
    codrem: r.codrem,
    fecha: r.fecha,
    factura: r.factura ? "Sí" : "",
    compraA,
    compraB,
    flete,
    pactado,
    pagado,
    saldo: Number(saldo.toFixed(2)),
  }] : [];

  setPreseleccionOP(pre);
  setShowModalOP(true);
};

  const abrirEditar = useCallback(async (row) => {
    try {
      const id = row.original._id;

      // limpio lo que haya
      setRemitoSel(null);

      const resp = await getRemitoById(id);
      console.log("👉 getRemitoById resp:", resp);

      // Soporta ambas formas: { ok, remito } o el doc directo
      const remito = resp?.remito || resp;

      if (remito && remito._id) {
        setRemitoSel(remito);     // cargamos datos
        setShowModalEdit(true);   // recién acá abrimos el modal
      } else {
        console.error("❌ Respuesta inesperada de getRemitoById:", resp);
        alert(
          resp?.msg ||
            resp?.error ||
            "No se pudo cargar el remito."
        );
      }
    } catch (e) {
      console.error("❌ Error getRemitoById:", e);
      alert("Error cargando el remito.");
    }
  }, []);

  const openOCFromRow = (row) => {
    const r = row.original;
    const cliente = r.cliente;
    if (!cliente?._id) {
      alert("El remito no tiene 'Cliente' asociado.");
      return;
    }
    setClienteOC(cliente);
    setProveedorOC(r.proveedor?._id ? r.proveedor : null); // filtro opcional

    const pactado = Number(r.totalVenta ?? r.total ?? 0);
    const cobrado = Number(r.cobradoCliente ?? r.cobrado ?? 0);
    const saldo = pactado - cobrado;
    const pre = saldo > 0.01 ? [{
      _id: r._id, codrem: r.codrem, fecha: r.fecha, factura: r.factura ? "Sí" : "",
      pactado, pagado: cobrado, saldo: Number(saldo.toFixed(2)),
    }] : [];
    setPreseleccionOC(pre);
    setShowModalOC(true);
  };

  const pdfRemito = useCallback((id) => {
    generarPDFRemito(id, {
      logoUrl: `${window.location.origin}/SanPancracio.png`,
      empresa: {
        nombre: "SAN PANCRACIO SRL",
        direccion: "Avda. Peron 1600 - Oficina 29 Piso 1 -Yerba Buena - Tucumán",
        telefono: "\n Tel: 0381-3008829",
        email: "contacto@sanpancracio.com",
      },
    });
  }, []);

  const pdfCampo = useCallback((id) => {
    generarPDFRemitoCampo(id, {
      logoUrl: `${window.location.origin}/SanPancracio.png`,
      // si tu drawHeader usa linea1/linea2, dejalo así:
      empresa: {
        nombre: "SAN PANCRACIO SRL",
        linea1: "Avda. Peron 1600 - Oficina 29 Piso 1 - Yerba Buena - Tucumán",
        linea2: "Tel: 0381-3008829 • contacto@sanpancracio.com",
      },
      // campoUrl es opcional porque el helper ya importa /src/images/campo.jpeg
      // campoUrl: `${window.location.origin}/images/campo.jpeg`,
    });
  }, []);


  const dataFiltrada = useMemo(() => {
    const dDesde = toStartOfDay(filtros.desde);
    const dHasta = toEndOfDay(filtros.hasta);

    const remDesde = filtros.remDesde !== "" ? Number(filtros.remDesde) : null;
    const remHasta = filtros.remHasta !== "" ? Number(filtros.remHasta) : null;

    return (data || []).filter((r) => {
      // Fecha
      const fISO = r?.fecha ? new Date(r.fecha).toISOString().slice(0, 10) : "";

      if (filtros.desde && (!fISO || fISO < filtros.desde)) return false;
      if (filtros.hasta && (!fISO || fISO > filtros.hasta)) return false;

      // Proveedor / Cliente / Chofer
      const prov = safeGet(r, "proveedor.razonsocial") || safeGet(r, "proveedor.proveedor") || "";
      const cli  = safeGet(r, "cliente.razonsocial")   || safeGet(r, "cliente.cliente")   || "";
      const chof = safeGet(r, "chofer.nombre")         || "";

      if (filtros.proveedor && !norm(prov).includes(norm(filtros.proveedor))) return false;
      if (filtros.cliente && !norm(cli).includes(norm(filtros.cliente))) return false;
      if (filtros.chofer && !norm(chof).includes(norm(filtros.chofer))) return false;

      // Rango Nro Remito (codrem)
      const cod = Number(r?.codrem || 0);
      if (remDesde != null && cod < remDesde) return false;
      if (remHasta != null && cod > remHasta) return false;

      return true;
    });
  }, [data, filtros]);


  const columns = useMemo(() => [
    // Acciones
    {
      id: "edit",
      Header: "Edita",
      accessor: "_id",
      width: 50,
      Cell: ({ row }) => (
        <button
          className="action-btn action-btn--edit"
          title="Editar remito"
          onClick={() => abrirEditar(row)}
        >
          <i className="fa fa-pencil" aria-hidden="true" />
        </button>
      ),
    },
    {
      id: "pdf",
      Header: "PDF",
      accessor: "_id",
      width: 50,
      Cell: ({ row }) => (
        <button
          className="action-btn action-btn--pdf { color: #dc3545; }"
          title="Descargar PDF Remito"
          onClick={() => pdfRemito(row.original._id)}
        >
          <i className="fa fa-file-pdf-o" aria-hidden="true" />
        </button>
      ),
    },

    
    // --------- Este Seria Info Campo---------
    {
      id: "pdfCampo",
      Header: "PDF C",
      accessor: "_id",
      width: 50,
      Cell: ({ row }) => (
        <button
          className="action-btn action-btn--pdfc { color: #6f42c1; }"
          title="Descargar Info Campo"
          onClick={() => pdfCampo(row.original._id)}
        >
          <i className="fa fa-file-pdf-o" aria-hidden="true" />
        </button>
      ),
    },

    // --------- OP (nuevo) ---------
    {
      id: "ordenPago",
      Header: "OP",
      accessor: "_id",
      width: 50,
      Cell: ({ row }) => (
        <button
          className="action-btn action-btn--op"
          title="Orden de Pago a proveedor"
          onClick={() => openOPFromRow(row)}
        >
          <i className="fa fa-bank" aria-hidden="true" />
        </button>
      ),
    },

    {
      id: "ordenCobro",
      Header: "OC",
      accessor: "_id",
      width: 30,
      Cell: ({ row }) => (
        <button
          className="action-btn action-btn--op"
          title="Orden de Cobro a cliente"
          onClick={() => openOCFromRow(row)}
        >
          <i className="fa fa-money" aria-hidden="true" />
        </button>
      ),
    },

    // Datos principales
    { Header: "Remito", accessor: "codrem", width: 80 },
    {
      Header: "Fecha",
      id: "fecha",
      width: 110,
      // Tomamos sólo la parte de fecha como string
      accessor: (row) => (row.fecha ? row.fecha.slice(0, 10) : ""),
      Cell: ({ value }) => (
        <div style={{ textAlign: "center" }}>
          {value
            ? value.split("-").reverse().join("/") // 2024-11-30 -> 30/11/2024
            : "-"}
        </div>
      ),
    },
    { Header: "Proveedor", accessor: "proveedor.razonsocial", width: 250 },
    { Header: "Cliente", accessor: "cliente.razonsocial", width: 250 },
    { Header: "Transporte", accessor: "transporte.transporte", width: 180 },

    // Nuevos
    { Header: "Chofer", accessor: "chofer.nombre", width: 180 },
    {
      Header: "Lote",
      id: "lote",
      width: 170,
      accessor: (r) =>
        r.lote
          ? (r.lote.codlote != null ? `#${r.lote.codlote} - ${r.lote.lote}` : r.lote.lote || "")
          : "",
      Cell: ({ value }) => <div style={{ textAlign: "left" }}>{value || "-"}</div>,
    },

    // Kilos
    {
      Header: "KG Campo",
      accessor: "kgCampo",
      id: "kgCampo",
      width: 100,
      Cell: ({ value }) => (
        <div style={{ textAlign: "right" }}>
          {Number(value || 0).toLocaleString("es-AR")}
        </div>
      ),
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.kgCampo || 0), 0);
        return (
          <div style={{ textAlign: "right", fontWeight: "bold", color: "blue" }}>
            {total.toLocaleString("es-AR")}
          </div>
        );
      },
    },
    {
      Header: "KG Recib.",
      accessor: "kgRecibido",
      id: "kgRecibido",
      width: 100,
      Cell: ({ value }) => (
        <div style={{ textAlign: "right" }}>
          {Number(value || 0).toLocaleString("es-AR")}
        </div>
      ),
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.kgRecibido || 0), 0);
        return (
          <div style={{ textAlign: "right", fontWeight: "bold", color: "blue" }}>
            {total.toLocaleString("es-AR")}
          </div>
        );
      },
    },
    {
      Header: "Dif",
      accessor: "diferencia",
      id: "diferencia",
      width: 90,
      Cell: ({ value }) => (
        <div style={{ textAlign: "right" }}>
          {Number(value || 0).toLocaleString("es-AR")}
        </div>
      ),
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.diferencia || 0), 0);
        return (
          <div style={{ textAlign: "right", fontWeight: "bold", color: "blue" }}>
            {total.toLocaleString("es-AR")}
          </div>
        );
      },
    },

    // Precios y totales
    {
      Header: "Precio Compra",
      accessor: "precioCompra",
      id: "precioCompra",
      width: 120,
      Cell: ({ value }) => <div style={{ textAlign: "right" }}>{fmtMoney(value)}</div>,
    },
    {
      Header: "Precio Venta",
      accessor: "precioVenta",
      id: "precioVenta",
      width: 120,
      Cell: ({ value }) => <div style={{ textAlign: "right" }}>{fmtMoney(value)}</div>,
    },
    {
      Header: "Total Compra",
      accessor: "totalCompra",
      id: "totalCompra",
      width: 130,
      Cell: ({ value }) => <div style={{ textAlign: "right" }}>{fmtMoney(value)}</div>,
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.totalCompra || 0), 0);
        return (
          <div style={{ textAlign: "right", fontWeight: "bold", color: "blue" }}>
            {fmtMoney(total)}
          </div>
        );
      },
    },
    {
      Header: "Compra A (blanco+IVA)",
      accessor: "totalCompraA",
      id: "totalCompraA",
      width: 140,
      Cell: ({ value }) => (
        <div style={{ textAlign: "right" }}>{fmtMoney(value)}</div>
      ),
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.totalCompraA || 0), 0);
        return (
          <div style={{ textAlign: "right", fontWeight: "bold", color: "blue" }}>
            {fmtMoney(total)}
          </div>
        );
      },
    },
    {
      Header: "Compra B (negro)",
      accessor: "totalCompraB",
      id: "totalCompraB",
      width: 140,
      Cell: ({ value }) => (
        <div style={{ textAlign: "right" }}>{fmtMoney(value)}</div>
      ),
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.totalCompraB || 0), 0);
        return (
          <div style={{ textAlign: "right", fontWeight: "bold", color: "blue" }}>
            {fmtMoney(total)}
          </div>
        );
      },
    },

    {
      Header: "Total Venta",
      accessor: "totalVenta",
      id: "totalVenta",
      width: 130,
      Cell: ({ value }) => <div style={{ textAlign: "right" }}>{fmtMoney(value)}</div>,
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.totalVenta || 0), 0);
        return (
          <div style={{ textAlign: "right", fontWeight: "bold", color: "red" }}>
            {fmtMoney(total)}
          </div>
        );
      },
    },
    {
      Header: "Venta A (blanco+IVA)",
      accessor: "totalVentaA",
      id: "totalVentaA",
      width: 140,
      Cell: ({ value }) => (
        <div style={{ textAlign: "right" }}>{fmtMoney(value)}</div>
      ),
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.totalVentaA || 0), 0);
        return (
          <div style={{ textAlign: "right", fontWeight: "bold", color: "red" }}>
            {fmtMoney(total)}
          </div>
        );
      },
    },
    {
      Header: "Venta B (negro)",
      accessor: "totalVentaB",
      id: "totalVentaB",
      width: 140,
      Cell: ({ value }) => (
        <div style={{ textAlign: "right" }}>{fmtMoney(value)}</div>
      ),
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.totalVentaB || 0), 0);
        return (
          <div style={{ textAlign: "right", fontWeight: "bold", color: "red" }}>
            {fmtMoney(total)}
          </div>
        );
      },
    },

    {
      Header: "Comisión",
      accessor: "comision",
      id: "comision",
      width: 120,
      Cell: ({ value }) => <div style={{ textAlign: "right" }}>{fmtMoney(value)}</div>,
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.comision || 0), 0);
        return (
          <div
            style={{
              textAlign: "right",
              fontWeight: "bold",
              color: total < 0 ? "red" : "green",
            }}
          >
            {fmtMoney(total)}
          </div>
        );
      },
    },
    {
      Header: "Flete",
      accessor: "flete",
      id: "flete",
      width: 110,
      Cell: ({ value }) => (
        <div style={{ textAlign: "right" }}>{fmtMoney(value)}</div>
      ),
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.flete || 0), 0);
        return (
          <div style={{ textAlign: "right", fontWeight: "bold", color: "green" }}>
            {fmtMoney(total)}
          </div>
        );
      },
    },

    { Header: "Nro DTV Compra", accessor: "nroDTVCompra", width: 150 },
    {
      Header: "% Compra B",
      accessor: "porcentajeCompra",
      id: "porcentajeCompra",
      width: 110,
      Cell: ({ value }) => (
        <div style={{ textAlign: "center" }}>
          {value != null ? `${Number(value || 0).toFixed(0)} %` : "-"}
        </div>
      ),
    },
    { Header: "Nro DTV Venta", accessor: "nroDTVVenta", width: 150 },
    {
      Header: "% Venta B",
      accessor: "porcentajeVenta",
      id: "porcentajeVenta",
      width: 110,
      Cell: ({ value }) => (
        <div style={{ textAlign: "center" }}>
          {value != null ? `${Number(value || 0).toFixed(0)} %` : "-"}
        </div>
      ),
    },
    {
      Header: "Factura",
      accessor: "factura",
      id: "factura",
      width: 90,
      Cell: ({ value }) => (
        <div style={{ textAlign: "center" }}>
          {value ? "✅" : "—"}
        </div>
      ),
    },

    { Header: "Variedad", accessor: "variedad", width: 180 },
    { Header: "Notas", accessor: "nota", width: 500 },
    {
      id: "del",
      Header: "Borra",
      accessor: "_id",
      width: 50,
      Cell: ({ row }) => (
        <button
          className="action-btn action-btn--del"
          title="Borrar remito"
          onClick={() => borrar(row.original._id)}
        >
          <i className="fa fa-trash" aria-hidden="true" />
        </button>
      ),
    },
  ], [abrirEditar, borrar, pdfRemito, pdfCampo]);

  return (
    <div className="container mt-4">
      <div className="position-relative mb-4">
        <h3 className="text-center mb-0">LISTADO DE REMITOS</h3>

      
        <div className="container mb-2" style={{ position: "relative" }}>
          <div className="row g-2 align-items-end">
            <div className="col-sm-2">
              <label className="form-label" style={{ fontSize: "1.5rem" }}>Fecha desde</label>
              <input type="date" className="form-control"
                    value={filtros.desde} onChange={(e) => setF("desde", e.target.value)} />
            </div>

            <div className="col-sm-2">
              <label className="form-label" style={{ fontSize: "1.5rem" }}>Fecha hasta</label>
              <input type="date" className="form-control"
                    value={filtros.hasta} onChange={(e) => setF("hasta", e.target.value)} />
            </div>

            <div className="col-sm-3">
              <label className="form-label" style={{ fontSize: "1.5rem" }}>Proveedor</label>
              <input className="form-control"
                    value={filtros.proveedor} onChange={(e) => setF("proveedor", e.target.value)} />
            </div>

            <div className="col-sm-3">
              <label className="form-label" style={{ fontSize: "1.5rem" }}>Cliente</label>
              <input className="form-control"
                    value={filtros.cliente} onChange={(e) => setF("cliente", e.target.value)} />
            </div>

            <div className="col-sm-2">
              <label className="form-label" style={{ fontSize: "1.5rem" }}>Chofer</label>
              <input className="form-control"
                    value={filtros.chofer} onChange={(e) => setF("chofer", e.target.value)} />
            </div>
          </div>

          <div className="row g-2 mt-2 align-items-end">
            <div className="col-sm-2">
              <label className="form-label" style={{ fontSize: "1.5rem" }}>Remito desde</label>
              <input type="number" className="form-control"
                    value={filtros.remDesde} onChange={(e) => setF("remDesde", e.target.value)} />
            </div>

            <div className="col-sm-2">
              <label className="form-label" style={{ fontSize: "1.5rem" }}>Remito hasta</label>
              <input type="number" className="form-control"
                    value={filtros.remHasta} onChange={(e) => setF("remHasta", e.target.value)} />
            </div>

            <div className="col-sm-3 d-flex gap-2 mt-4" style={{ width: 360, height: 40 }}>
              <button className="btn btn-outline-secondary btn-sm flex-fill"
                      onClick={quickHoy}
                      style={{ fontSize: 16, lineHeight: 1.1, padding: "8px 12px" }}>
                Hoy
              </button>

              <button className="btn btn-outline-success btn-sm flex-fill"
                      onClick={quickUltimos7}
                      style={{ fontSize: 16, lineHeight: 1.1, padding: "8px 12px" }}>
                7 días
              </button>

              <button className="btn btn-outline-primary btn-sm flex-fill"
                      onClick={limpiarFiltros}
                      style={{ fontSize: 16, lineHeight: 1.1, padding: "8px 12px" }}>
                Limpiar
              </button>
            </div>
          </div>
        </div>

        <Button
          variant="dark"
          className="position-absolute end-0"
          style={{
            top: "110px",          // 👈 baja el botón (ajustá 70–110 según tu layout)
            zIndex: 20,
            whiteSpace: "nowrap",
            padding: "10px 14px", // 👈 más grande
            fontSize: "16px",     // 👈 más grande
            borderRadius: "10px",
          }}
          onClick={() => setShowSaldo(true)}
        >
          Saldo Inicial (1..100)
        </Button>

      </div>

      <Styles>
        <div className="table-container">
          <Table
            columns={columns}
            data={dataFiltrada}
            loading={loading}
            plugins={[useFilters, useSortBy, usePagination]}
            pageSize={10}
          />
        </div>
      </Styles>

      <ModalFormRemito
        show={showModalEdit}
        remito={remitoSel}
        onClose={handleCloseEdit}
      />

      {/* 👇 Modal de Orden de Pago de Remitos */}
      <ModalOrdenPagoRemito
        show={showModalOP}
        onHide={(saved) => {
          setShowModalOP(false);
          setProveedorOP(null);
          setClienteOP(null);
          setPreseleccionOP([]);
          if (saved) fetchData(); // refresca si se guardó OP
        }}
        proveedor={proveedorOP}
        cliente={clienteOP}
        remitosPreseleccionados={preseleccionOP}
      />

      <ModalOrdenCobroRemitos
        show={showModalOC}
        onHide={(saved) => {
          setShowModalOC(false);
          setClienteOC(null);
          setProveedorOC(null);
          setPreseleccionOC([]);
          if (saved) fetchData();
        }}
        cliente={clienteOC}
        proveedor={proveedorOC}
        preseleccion={preseleccionOC}
      />
      <ModalSaldoInicialRemito
        show={showSaldo}
        onClose={() => setShowSaldo(false)}
        onSaved={() => fetchData()}   // ✅ acá
      />

    </div>
  );
}
